// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__Sl","cls2":"Unibrow-cls2___q Unibrow-cls1__Sl"};